import React from 'react';
import PropTypes from 'prop-types';

const SelectBox = ({ disabledClass, selectTitle, children }) => (
    <div className={`sb-filter__selectBox col-xs-12 ${disabledClass}`}>
        <label className="sb-filter__selectBox__label" htmlFor="">
            {selectTitle}
        </label>
        {children}
    </div>
);


SelectBox.propTypes = {
    selectTitle: PropTypes.string.isRequired,
    disabledClass: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default SelectBox;



// WEBPACK FOOTER //
// ./src/client/components/SelectBox.js